import React, { forwardRef, useState } from "react";
import DatePicker from "react-datepicker";

import { formatDate } from "../../helpers";

const DatePickerButton = forwardRef(({ value, onClick }, ref) => {
  const [year, month, day, hour, minutes] = value.split(" ");
  const d = new Date(`${year}-${month}-${day} ${hour}:${minutes}`);

  return (
    <button className="small" onClick={onClick} ref={ref}>
      Change timing
    </button>
  );
});

export default function PickDate({ onSelect }: { onSelect: Function }) {
  const [selectedDate, setDate] = useState<Date>(new Date());
  const publishNow = new Date().getTime() >= selectedDate.getTime();

  return (
    <div className="scheduler-phase fulfilled">
      You are about to publish
      {publishNow ? (
        <>
          <strong> now</strong>.
        </>
      ) : (
        <>
          {" "}
          on <strong>{formatDate(selectedDate)}</strong>.
        </>
      )}
      <div className="mt1">
        <DatePicker
          selected={selectedDate}
          onChange={(date) => {
            setDate(date);
          }}
          showTimeSelect
          timeFormat="HH mm"
          dateFormat="yyyy MM d HH mm"
          timeIntervals={15}
          customInput={<DatePickerButton />}
          onCalendarClose={() => {
            onSelect(selectedDate);
          }}
        />
      </div>
    </div>
  );
}
